import { TranslationObject } from '../i18n/translation';

const namespace = 'siktLogo';

const translations: TranslationObject = {
  title: {
    id: `${namespace}.title`,
    nb: 'Sikt - Kunnskapssektorens tjenesteleverandør',
    en: 'Sikt - Norwegian Agency for Shared Services in Education and Research',
  },
};

export default translations;
